module.exports = __webpack_public_path__ + "static/media/404.b089ba6e.svg";